import { ChangeDetectionStrategy, Component, DestroyRef, inject, Input, OnDestroy, SimpleChanges } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { BehaviorSubject, filter, map, Observable, shareReplay, take, tap } from 'rxjs';
import { DetailsConfig, SharedUiDetailsModule } from '@snelstart/ui-details';
import { BokkzClient, BokkzIbDataService, IncomeTaxEntity } from '@snelstart-ventures/fiscaal/domain-logic';
import { ButtonConfiguration, SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiTabModule } from '@snelstart/ui-tab';
import { CommonModule } from '@angular/common';
import { AangeverComponent } from '../income/persoonlijk/aangever/aangever.component';
import { RelatiegegevensComponent } from '../income/persoonlijk/relatiegegevens/relatiegegevens.component';
import { PartnerComponent } from '../income/persoonlijk/partner/partner.component';
import { KindComponent } from '../income/persoonlijk/kind/kind.component';
import { AlgemeenComponent } from '../income/box1/box1-winst-uit-onderneming/onderneming/algemeen/algemeen.component';
import {
  AdministratieKoppelenIbComponent
} from '../income/box1/box1-winst-uit-onderneming/onderneming/administratie-koppelen-ib/administratie-koppelen-ib.component';
import {
  VragenVoorafOndComponent
} from '../income/box1/box1-winst-uit-onderneming/onderneming/vragen-vooraf-ond/vragen-vooraf-ond.component';
import {
  WinstEnVerliesComponent
} from '../income/box1/box1-winst-uit-onderneming/onderneming/winst-en-verlies/winst-en-verlies.component';
import {
  BalansActivaComponent
} from '../income/box1/box1-winst-uit-onderneming/onderneming/balans/balans-activa/balans-activa.component';
import {
  BalansPassivaComponent
} from '../income/box1/box1-winst-uit-onderneming/onderneming/balans/balans-passiva/balans-passiva.component';
import {
  SamenwerkingsverbandComponent
} from '../income/box1/box1-winst-uit-onderneming/onderneming/samenwerkingsverband/samenwerkingsverband.component';
import {
  PriveOntrekkingenEnStortingenComponent
} from '../income/box1/box1-winst-uit-onderneming/onderneming/prive-ontrekkingen-en-stortingen/prive-ontrekkingen-en-stortingen.component';
import {
  VermogensvergelijkingComponent
} from '../income/box1/box1-winst-uit-onderneming/onderneming/vermogensvergelijking/vermogensvergelijking.component';
import {
  InvesteringenComponent
} from '../income/box1/box1-winst-uit-onderneming/onderneming/investeringen/investeringen.component';
import {
  WinstcorrectiesComponent
} from '../income/box1/box1-winst-uit-onderneming/onderneming/winstcorrecties/winstcorrecties.component';
import { OndernemerComponent } from '../income/box1/box1-winst-uit-onderneming/ondernemer/ondernemer.component';
import {
  Box1WinstUitOndernemingComponent
} from '../income/box1/box1-winst-uit-onderneming/box1-winst-uit-onderneming.component';
import {
  LoonTegenwoordigComponent
} from '../income/box1/box1-belastbaar-loon/loon-tegenwoordig/loon-tegenwoordig.component';
import { ReisaftrekOvComponent } from '../income/box1/box1-belastbaar-loon/reisaftrek-ov/reisaftrek-ov.component';
import { LoonVroegerComponent } from '../income/box1/box1-belastbaar-loon/loon-vroeger/loon-vroeger.component';
import { LoonBuitenlandComponent } from '../income/box1/box1-belastbaar-loon/loon-buitenland/loon-buitenland.component';
import {
  LoonInternationaleOrganisatieComponent
} from '../income/box1/box1-belastbaar-loon/loon-internationale-organisatie/loon-internationale-organisatie.component';
import {
  MeerBanenTegelijkComponent
} from '../income/box1/box1-belastbaar-loon/meer-banen-tegelijk/meer-banen-tegelijk.component';
import { Box1BelastbaarLoonComponent } from '../income/box1/box1-belastbaar-loon/box1-belastbaar-loon.component';
import {
  ResultaatUitOverigeWerkzaamhedenComponent
} from '../income/box1/box1-resultaat-overige-werkzaamheden/resultaat-uit-overige-werkzaamheden/resultaat-uit-overige-werkzaamheden.component';
import {
  AlimentatieComponent
} from '../income/box1/box1-belastbare-periodieke-uitkeringen-en-verstrekkingen/alimentatie/alimentatie.component';
import {
  PeriodiekeUitkeringenComponent
} from '../income/box1/box1-belastbare-periodieke-uitkeringen-en-verstrekkingen/periodieke-uitkeringen/periodieke-uitkeringen.component';
import {
  Box1ResultaatOverigeWerkzaamhedenComponent
} from '../income/box1/box1-resultaat-overige-werkzaamheden/box1-resultaat-overige-werkzaamheden.component';
import {
  Box1BelastbareInkomstenOpBasisVanOvergangsrechtComponent
} from '../income/box1/box1-belastbare-inkomsten-op-basis-van-overgangsrecht/box1-belastbare-inkomsten-op-basis-van-overgangsrecht.component';
import {
  EigenwoningenComponent
} from '../income/box1/box1-belastbare-inkomsten-uit-eigenwoning/eigenwoningen/eigenwoningen.component';
import {
  EigenwoningSchuldenComponent
} from '../income/box1/box1-belastbare-inkomsten-uit-eigenwoning/eigenwoning-schulden/eigenwoning-schulden.component';
import {
  FinancieringskostenComponent
} from '../income/box1/box1-belastbare-inkomsten-uit-eigenwoning/financieringskosten/financieringskosten.component';
import {
  EigenwoningRestschuldenComponent
} from '../income/box1/box1-belastbare-inkomsten-uit-eigenwoning/eigenwoning-restschulden/eigenwoning-restschulden.component';
import {
  HuurinkomstenComponent
} from '../income/box1/box1-belastbare-inkomsten-uit-eigenwoning/huurinkomsten/huurinkomsten.component';
import {
  OverigEigenWoningComponent
} from '../income/box1/box1-belastbare-inkomsten-uit-eigenwoning/overig-eigen-woning/overig-eigen-woning.component';
import {
  Box1BelastbareInkomstenUitEigenwoningComponent
} from '../income/box1/box1-belastbare-inkomsten-uit-eigenwoning/box1-belastbare-inkomsten-uit-eigenwoning.component';
import {
  LijfrentePremiesComponent
} from '../income/box1/box1-uitgaven-voor-inkomensvoorzieningen/lijfrente/lijfrente-premies/lijfrente-premies.component';
import {
  JaarruimtegegevensComponent
} from '../income/box1/box1-uitgaven-voor-inkomensvoorzieningen/lijfrente/jaarruimtegegevens/jaarruimtegegevens.component';
import {
  OverigePremiesComponent
} from '../income/box1/box1-uitgaven-voor-inkomensvoorzieningen/overige-premies/overige-premies.component';
import {
  Box1UitgavenVoorInkomensvoorzieningenComponent
} from '../income/box1/box1-uitgaven-voor-inkomensvoorzieningen/box1-uitgaven-voor-inkomensvoorzieningen.component';
import {
  Box1NegatieveUitgavenVoorInkomensvoorzieningenComponent
} from '../income/box1/box1-negatieve-uitgaven-voor-inkomensvoorzieningen/box1-negatieve-uitgaven-voor-inkomensvoorzieningen.component';
import {
  Box2InkomenUitAanmerkelijkBelangComponent
} from '../income/box2/box2-inkomen-uit-aanmerkelijk-belang/box2-inkomen-uit-aanmerkelijk-belang.component';
import {
  Box2InkomenUitAanmerkelijkBelangSamenvattingComponent
} from '../income/box2/box2-inkomen-uit-aanmerkelijk-belang.component';
import { Box3OwrComponent } from '../income/box3/box3-owr/box3-owr.component';
import { Box3BankrekeningenComponent } from '../income/box3/box3-bankrekeningen/box3-bankrekeningen.component';
import {
  Box3BeleggingsrekeningenComponent
} from '../income/box3/box3-beleggingsrekeningen/box3-beleggingsrekeningen.component';
import {
  Box3OverigeOnroerendeZakenComponent
} from '../income/box3/box3-overige-onroerende-zaken/box3-overige-onroerende-zaken.component';
import {
  Box3OverigeBezittingenComponent
} from '../income/box3/box3-overige-bezittingen/box3-overige-bezittingen.component';
import { Box3LeningenComponent } from '../income/box3/box3-leningen/box3-leningen.component';
import { Box3Component } from '../income/box3/box3.component';
import {
  PgaSpecifiekeZorgkostenComponent
} from '../income/persoonsgebonden-aftrek/pga-specifieke-zorgkosten/pga-specifieke-zorgkosten.component';
import {
  PgaAftrekbareGiftenComponent
} from '../income/persoonsgebonden-aftrek/pga-aftrekbare-giften/pga-aftrekbare-giften.component';
import {
  PgaOnderhoudsverplichtingenComponent
} from '../income/persoonsgebonden-aftrek/pga-onderhoudsverplichtingen/pga-onderhoudsverplichtingen.component';
import {
  PgaWeekenduitgavenGehandicapteKinderenComponent
} from '../income/persoonsgebonden-aftrek/pga-weekenduitgaven-gehandicapte-kinderen/pga-weekenduitgaven-gehandicapte-kinderen.component';
import {
  PgaRestantPgaVoorgaandeJarenComponent
} from '../income/persoonsgebonden-aftrek/pga-restant-pga-voorgaande-jaren/pga-restant-pga-voorgaande-jaren.component';
import {
  Box1NegatievePersoonsgebondenAftrekComponent
} from '../income/box1/box1-negatieve-persoonsgebonden-aftrek/box1-negatieve-persoonsgebonden-aftrek.component';
import {
  PgaSamenvattingComponent
} from '../income/persoonsgebonden-aftrek/pga-samenvatting/pga-samenvatting.component';
import { VerdelingComponent } from '../income/verdeling/verdeling.component';
import {
  VoorlopigeAanslagenComponent
} from '../income/voorheffingen/voorlopige-aanslagen/voorlopige-aanslagen.component';
import { DividendbelastingComponent } from '../income/voorheffingen/dividendbelasting/dividendbelasting.component';
import {
  BuitenlandseBronheffingComponent
} from '../income/voorheffingen/buitenlandse-bronheffing/buitenlandse-bronheffing.component';
import {
  LoonOnderdeelWinstComponent
} from '../income/voorheffingen/loon-onderdeel-winst/loon-onderdeel-winst.component';
import { VerrekenbareVerliezenComponent } from '../income/verrekenbare-verliezen/verrekenbare-verliezen.component';
import {
  OverzichtInkomenBox1Component
} from '../income/overzicht/overzicht-inkomen-box1/overzicht-inkomen-box1.component';
import { IbOverzichtComponent } from '../income/overzicht/ib-overzicht.component';
import { PremieplichtComponent } from '../income/premieplicht/premieplicht.component';
import { ConserverendInkomenComponent } from '../income/conserverend-inkomen/conserverend-inkomen.component';
import { ApvLijstComponent } from '../income/apv-lijst/apv-lijst.component';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import {
  TekstPersoonlijkAangeverComponent
} from '../income/toelichtingen-tekst/tekst-persoonlijk-aangever/tekst-persoonlijk-aangever.component';
import {
  TekstPersoonlijkWijzigingBurgerlijkeStaatComponent
} from '../income/toelichtingen-tekst/tekst-persoonlijk-wijzigingBurgerlijkeStaat/tekst-persoonlijk-wijzigingBurgerlijkeStaat.component';
import {
  TekstPersoonlijkPartnerComponent
} from '../income/toelichtingen-tekst/tekst-persoonlijk-partner/tekst-persoonlijk-partner.component';
import {
  TekstPersoonlijkKinderenComponent
} from '../income/toelichtingen-tekst/tekst-persoonlijk-kinderen/tekst-persoonlijk-kinderen.component';
import {
  TekstWuoOndernemingComponent
} from '../income/toelichtingen-tekst/tekst-wuo-onderneming/tekst-wuo-onderneming.component';
import {
  TekstWuoAdminKoppelenComponent
} from '../income/toelichtingen-tekst/tekst-wuo-adminKoppelen/tekst-wuo-adminKoppelen.component';
import {
  TekstOndernemingVragenVoorafComponent
} from '../income/toelichtingen-tekst/tekst-wuo-vragenVooraf/tekst-wuo-vragenVooraf.component';
import {
  TekstWuoResultatenrekeningComponent
} from '../income/toelichtingen-tekst/tekst-wuo-resultatenrekening/tekst-wuo-resultatenrekening.component';
import {
  TekstWuoBalansActivaComponent
} from '../income/toelichtingen-tekst/tekst-wuo-balansActiva/tekst-wuo-balansActiva.component';
import {
  TekstWuoBalansPassivaComponent
} from '../income/toelichtingen-tekst/tekst-wuo-balansPassiva/tekst-wuo-balansPassiva.component';
import {
  TekstOndernemingPriveComponent
} from '../income/toelichtingen-tekst/tekst-wuo-prive/tekst-wuo-prive.component';
import {
  TekstOndernemingVermogensVergelijkingComponent
} from '../income/toelichtingen-tekst/tekst-wuo-vermogensVergelijking/tekst-wuo-vermogensVergelijking.component';
import {
  TekstOndernemingInvesteringenComponent
} from '../income/toelichtingen-tekst/tekst-wuo-investeringen/tekst-wuo-investeringen.component';
import {
  TekstOndernemingWinstcorrectiesComponent
} from '../income/toelichtingen-tekst/tekst-wuo-winstcorrecties/tekst-wuo-winstcorrecties.component';
import {
  TekstOaOndernemersaftrekComponent
} from '../income/toelichtingen-tekst/tekst-oa-ondernemersaftrek/tekst-oa-ondernemersaftrek.component';
import {
  TekstLoonLoondienstComponent
} from '../income/toelichtingen-tekst/tekst-loon-loondienst/tekst-loon-loondienst.component';
import {
  SnelstartVentureFiscaalFeatureTekstLoonReiskostenOvComponent
} from '../income/toelichtingen-tekst/tekst-loon-reiskostenOv/snelstart-venture-fiscaal-feature-tekst-loon-reiskostenOv.component';
import {
  TekstLoonPensioenComponent
} from '../income/toelichtingen-tekst/tekst-loon-pensioen/tekst-loon-pensioen.component';
import {
  TekstLoonBuitenlandComponent
} from '../income/toelichtingen-tekst/tekst-loon-buitenland/tekst-loon-buitenland.component';
import {
  TekstLoonVrijgesteldComponent
} from '../income/toelichtingen-tekst/tekst-loon-vrijgesteld/tekst-loon-vrijgesteld.component';
import {
  TekstLoonMeerBanenComponent
} from '../income/toelichtingen-tekst/tekst-loon-meerBanen/tekst-loon-meerBanen.component';
import {
  TekstOverigInkomenRowComponent
} from '../income/toelichtingen-tekst/tekst-overigInkomen-row/tekst-overigInkomen-row.component';
import {
  TekstOverigInkomenTbsComponent
} from '../income/toelichtingen-tekst/tekst-overigInkomen-tbs/tekst-overigInkomen-tbs.component';
import {
  TekstOverigInkomenAlimentatieComponent
} from '../income/toelichtingen-tekst/tekst-overigInkomen-alimentatie/tekst-overigInkomen-alimentatie.component';
import {
  TekstOverigInkomenPuComponent
} from '../income/toelichtingen-tekst/tekst-overigInkomen-pu/tekst-overigInkomen-pu.component';
import {
  TekstWoningWoningenComponent
} from '../income/toelichtingen-tekst/tekst-woning-woningen/tekst-woning-woningen.component';
import { TekstWoningEwsComponent } from '../income/toelichtingen-tekst/tekst-woning-ews/tekst-woning-ews.component';
import {
  TekstWoningFinancieringskostenComponent
} from '../income/toelichtingen-tekst/tekst-woning-financieringskosten/tekst-woning-financieringskosten.component';
import {
  TekstWoningRestschuldenComponent
} from '../income/toelichtingen-tekst/tekst-woning-restschulden/tekst-woning-restschulden.component';
import {
  TekstWoningHuurinkomstenComponent
} from '../income/toelichtingen-tekst/tekst-woning-huurinkomsten/tekst-woning-huurinkomsten.component';
import {
  TekstWoningOverigComponent
} from '../income/toelichtingen-tekst/tekst-woning-overig/tekst-woning-overig.component';
import {
  TekstPremiesLijfrenteComponent
} from '../income/toelichtingen-tekst/tekst-premies-lijfrente/tekst-premies-lijfrente.component';
import {
  TekstPremiesJaarruimteComponent
} from '../income/toelichtingen-tekst/tekst-premies-jaarruimte/tekst-premies-jaarruimte.component';
import {
  TekstPremiesOverigComponent
} from '../income/toelichtingen-tekst/tekst-premies-overig/tekst-premies-overig.component';
import {
  TekstPremiesTeruggaveComponent
} from '../income/toelichtingen-tekst/tekst-premies-teruggave/tekst-premies-teruggave.component';
import { TekstAbInkomenComponent } from '../income/toelichtingen-tekst/tekst-ab-inkomen/tekst-ab-inkomen.component';
import { TekstBox3BankComponent } from '../income/toelichtingen-tekst/tekst-box3-bank/tekst-box3-bank.component';
import {
  TekstBox3BeleggingenComponent
} from '../income/toelichtingen-tekst/tekst-box3-beleggingen/tekst-box3-beleggingen.component';
import {
  TekstBox3OnrZakenComponent
} from '../income/toelichtingen-tekst/tekst-box3-onrZaken/tekst-box3-onrZaken.component';
import { TekstBox3OverigComponent } from '../income/toelichtingen-tekst/tekst-box3-overig/tekst-box3-overig.component';
import {
  TekstBox3SchuldenComponent
} from '../income/toelichtingen-tekst/tekst-box3-schulden/tekst-box3-schulden.component';
import { TekstPgaZorgComponent } from '../income/toelichtingen-tekst/tekst-pga-zorg/tekst-pga-zorg.component';
import { TekstPgaGiftenComponent } from '../income/toelichtingen-tekst/tekst-pga-giften/tekst-pga-giften.component';
import {
  TekstPgaScholingComponent
} from '../income/toelichtingen-tekst/tekst-pga-scholing/tekst-pga-scholing.component';
import {
  TekstPgaOnderhoudComponent
} from '../income/toelichtingen-tekst/tekst-pga-onderhoud/tekst-pga-onderhoud.component';
import { TekstPgaWeekendComponent } from '../income/toelichtingen-tekst/tekst-pga-weekend/tekst-pga-weekend.component';
import { TekstPgaRestantComponent } from '../income/toelichtingen-tekst/tekst-pga-restant/tekst-pga-restant.component';
import {
  TekstPgaNegatiefComponent
} from '../income/toelichtingen-tekst/tekst-pga-negatief/tekst-pga-negatief.component';
import {
  TekstVoorheffingenVaComponent
} from '../income/toelichtingen-tekst/tekst-voorheffingen-va/tekst-voorheffingen-va.component';
import {
  TekstVoorheffingenDivBelComponent
} from '../income/toelichtingen-tekst/tekst-voorheffingen-divBel/tekst-voorheffingen-divBel.component';
import {
  TekstVoorheffingenBuitenlBronbelComponent
} from '../income/toelichtingen-tekst/tekst-voorheffingen-buitenlBronbel/tekst-voorheffingen-buitenlBronbel.component';
import {
  TekstVoorheffingenLoonWinstComponent
} from '../income/toelichtingen-tekst/tekst-voorheffingen-loonWinst/tekst-voorheffingen-loonWinst.component';
import { TekstVerrVerliesComponent } from '../income/toelichtingen-tekst/tekst-verrVerlies/tekst-verrVerlies.component';
import { TekstVerdelingComponent } from '../income/toelichtingen-tekst/tekst-verdeling/tekst-verdeling.component';
import {
  TbsRegelingComponent
} from '../income/box1/box1-resultaat-overige-werkzaamheden/tbs-regeling/tbs-regeling.component';
import {
  TekstBerekeningBelastingComponent
} from '../income/toelichtingen-tekst/tekst-berekening-belasting/tekst-berekening-belasting.component';
import {
  TekstBerekeningPremieZvwComponent
} from '../income/toelichtingen-tekst/tekst-berekening-premieZvw/tekst-berekening-premieZvw.component';
import {
  TekstBox3WerkelijkRendementComponent
} from '../income/toelichtingen-tekst/tekst-box3-werkelijkRendement/tekst-box3-werkelijkRendement.component';
import { InlezenComponent } from '../income/inlezen/inlezen.component';
import { OpgaafWereldinkomenComponent } from '../income/wereldinkomen/opgaaf-wereldinkomen.component';
import { SharedUiLoadingModule } from '@snelstart/ui-loading';
import {
  TekstPremievrijstellingComponent
} from '../income/toelichtingen-tekst/tekst-premievrijstelling/tekst-premievrijstelling.component';
import {
  TekstWereldinkomenComponent
} from '../income/toelichtingen-tekst/tekst-wereldinkomen/tekst-wereldinkomen.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastService } from '@snelstart/ui-toast';
import {
  OverzichtInkomenBox2Component
} from '../income/overzicht/overzicht-inkomen-box2/overzicht-inkomen-box2.component';
import {
  OverzichtInkomenBox3Component
} from '../income/overzicht/overzicht-inkomen-box3/overzicht-inkomen-box3.component';
import {
  ZorgverzekeringswetComponent
} from '../income/overzicht/overzicht-zorgverzekeringswet/zorgverzekeringswet.component';
import {
  StudiefinancieringAangeverComponent
} from '../income/persoonsgebonden-aftrek/pga-scholingsuitgaven/studiefinanciering-aangever.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'snelstart-venture-fiscaal-feature-tax-income-details',
  templateUrl: './feature-tax-income-details.component.html',
  imports: [
    CommonModule,
    SharedUiDetailsModule,
    SharedUiTabModule,
    AangeverComponent,
    RelatiegegevensComponent,
    PartnerComponent,
    KindComponent,
    AlgemeenComponent,
    AdministratieKoppelenIbComponent,
    VragenVoorafOndComponent,
    WinstEnVerliesComponent,
    BalansActivaComponent,
    BalansPassivaComponent,
    SamenwerkingsverbandComponent,
    PriveOntrekkingenEnStortingenComponent,
    VermogensvergelijkingComponent,
    InvesteringenComponent,
    WinstcorrectiesComponent,
    OndernemerComponent,
    Box1WinstUitOndernemingComponent,
    LoonTegenwoordigComponent,
    ReisaftrekOvComponent,
    LoonVroegerComponent,
    LoonBuitenlandComponent,
    LoonInternationaleOrganisatieComponent,
    MeerBanenTegelijkComponent,
    Box1BelastbaarLoonComponent,
    ResultaatUitOverigeWerkzaamhedenComponent,
    AlimentatieComponent,
    PeriodiekeUitkeringenComponent,
    Box1ResultaatOverigeWerkzaamhedenComponent,
    Box1BelastbareInkomstenOpBasisVanOvergangsrechtComponent,
    EigenwoningenComponent,
    EigenwoningSchuldenComponent,
    FinancieringskostenComponent,
    EigenwoningRestschuldenComponent,
    HuurinkomstenComponent,
    OverigEigenWoningComponent,
    Box1BelastbareInkomstenUitEigenwoningComponent,
    LijfrentePremiesComponent,
    JaarruimtegegevensComponent,
    OverigePremiesComponent,
    Box1UitgavenVoorInkomensvoorzieningenComponent,
    Box1NegatieveUitgavenVoorInkomensvoorzieningenComponent,
    Box2InkomenUitAanmerkelijkBelangComponent,
    Box2InkomenUitAanmerkelijkBelangSamenvattingComponent,
    Box3OwrComponent,
    Box3BankrekeningenComponent,
    Box3BeleggingsrekeningenComponent,
    Box3OverigeOnroerendeZakenComponent,
    Box3OverigeBezittingenComponent,
    Box3LeningenComponent,
    Box3Component,
    PgaSpecifiekeZorgkostenComponent,
    PgaAftrekbareGiftenComponent,
    PgaOnderhoudsverplichtingenComponent,
    PgaWeekenduitgavenGehandicapteKinderenComponent,
    PgaRestantPgaVoorgaandeJarenComponent,
    Box1NegatievePersoonsgebondenAftrekComponent,
    PgaSamenvattingComponent,
    VerdelingComponent,
    VoorlopigeAanslagenComponent,
    DividendbelastingComponent,
    BuitenlandseBronheffingComponent,
    LoonOnderdeelWinstComponent,
    VerrekenbareVerliezenComponent,
    OverzichtInkomenBox1Component,
    ZorgverzekeringswetComponent,
    IbOverzichtComponent,
    PremieplichtComponent,
    ConserverendInkomenComponent,
    ApvLijstComponent,
    SharedUiButtonModule,
    SharedUiDialogModule,
    TekstPersoonlijkAangeverComponent,
    TekstPersoonlijkWijzigingBurgerlijkeStaatComponent,
    TekstPersoonlijkPartnerComponent,
    TekstPersoonlijkKinderenComponent,
    TekstWuoOndernemingComponent,
    TekstWuoAdminKoppelenComponent,
    TekstOndernemingVragenVoorafComponent,
    TekstWuoResultatenrekeningComponent,
    TekstWuoBalansActivaComponent,
    TekstWuoBalansPassivaComponent,
    TekstOndernemingPriveComponent,
    TekstOndernemingVermogensVergelijkingComponent,
    TekstOndernemingInvesteringenComponent,
    TekstOndernemingWinstcorrectiesComponent,
    TekstOaOndernemersaftrekComponent,
    TekstLoonLoondienstComponent,
    SnelstartVentureFiscaalFeatureTekstLoonReiskostenOvComponent,
    TekstLoonPensioenComponent,
    TekstLoonBuitenlandComponent,
    TekstLoonVrijgesteldComponent,
    TekstLoonMeerBanenComponent,
    TekstOverigInkomenRowComponent,
    TekstOverigInkomenTbsComponent,
    TekstOverigInkomenAlimentatieComponent,
    TekstOverigInkomenPuComponent,
    TekstWoningWoningenComponent,
    TekstWoningEwsComponent,
    TekstWoningFinancieringskostenComponent,
    TekstWoningRestschuldenComponent,
    TekstWoningHuurinkomstenComponent,
    TekstWoningOverigComponent,
    TekstPremiesLijfrenteComponent,
    TekstPremiesJaarruimteComponent,
    TekstPremiesOverigComponent,
    TekstPremiesTeruggaveComponent,
    TekstAbInkomenComponent,
    TekstBox3BankComponent,
    TekstBox3BeleggingenComponent,
    TekstBox3OnrZakenComponent,
    TekstBox3OverigComponent,
    TekstBox3SchuldenComponent,
    TekstPgaZorgComponent,
    TekstPgaGiftenComponent,
    TekstPgaScholingComponent,
    TekstPgaOnderhoudComponent,
    TekstPgaWeekendComponent,
    TekstPgaRestantComponent,
    TekstPgaNegatiefComponent,
    TekstVoorheffingenVaComponent,
    TekstVoorheffingenDivBelComponent,
    TekstVoorheffingenBuitenlBronbelComponent,
    TekstVoorheffingenLoonWinstComponent,
    TekstVerrVerliesComponent,
    TekstVerdelingComponent,
    TbsRegelingComponent,
    TekstBerekeningBelastingComponent,
    TekstBerekeningPremieZvwComponent,
    TekstBox3WerkelijkRendementComponent,
    InlezenComponent,
    OpgaafWereldinkomenComponent,
    SharedUiLoadingModule,
    TekstPremievrijstellingComponent,
    TekstWereldinkomenComponent,
    OverzichtInkomenBox2Component,
    OverzichtInkomenBox3Component,
    StudiefinancieringAangeverComponent
  ],
  styleUrls: ['./feature-tax-income-details.component.scss']
})
export class FeatureTaxIncomeDetailsComponent implements OnDestroy {

  @Input() public id!: string;
  @Input() public partner = new BehaviorSubject<boolean>(false);
  private readonly destroyRef = inject(DestroyRef);
  public readonly dataService = inject(BokkzIbDataService);
  private readonly bokkzClient = inject(BokkzClient);
  private readonly toastService = inject(ToastService);
  private readonly cdr = inject(ChangeDetectorRef);
  public onderdeelVisible$ = new BehaviorSubject<string>('Vragen vooraf');
  public jaarstukkenOpen = false;
  public year: any;
  public linkFiscaleInfo: any;
  public dialogInfoVisible = false;

  public detailsConfig = DetailsConfig.create({
    showArrowButtons: false
  });

  readonly incomeTaxEntity$: Observable<IncomeTaxEntity> = this.dataService.incomeTaxEntity$.pipe(
    filter((data): data is IncomeTaxEntity => !!data?.sstRelationId),
    tap((data) => {
      if (data.aangifte) {
        this.year = data.year;
        this.linkFiscaleInfo = this.belastingdienstFisinUrl;
      }
    }),
    takeUntilDestroyed(this.destroyRef),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  readonly partnerAangifte$: Observable<boolean> = this.dataService.partnerAangifte$.pipe(
    tap((data) => {
      this.partner.next(data);
    }),
    takeUntilDestroyed(this.destroyRef),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['id'] && this.id !== 'Ondernemingen') {
      this.jaarstukkenOpen = false;
      this.onderdeelVisible$.next('');
    }
  }

  ngOnDestroy(): void {
    // No-op: lifecycle cleanup is handled via takeUntilDestroyed.
    this.closeJaarstukken();
  }

  openJaarstukken(index: number): void {
    this.dataService.indexOnderneming.next(index);
    this.jaarstukkenOpen = true;
    this.onderdeelVisible$.next('Vragen vooraf');
  }

  closeJaarstukken(): void {
    this.onderdeelVisible$.next('');
    this.jaarstukkenOpen = false;
  }

  showDialogInfo() {
    this.dialogInfoVisible = true;
  }

  onSelectTab(partner: boolean) {
    this.dataService.partnerAangifte.next(partner);
  }

  onSelectOnderdeel(onderdeel: string) {
    this.onderdeelVisible$.next(onderdeel);
  }

  getNaamOnderneming(): string | undefined {
    const isPartner = this.dataService.partnerAangifte.value;
    const indexOnderneming = this.dataService.indexOnderneming.value;
    if (isPartner) {
      return this.dataService.incomeTaxEntity.value?.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen?.at(
        indexOnderneming
      )?.naam;
    }
    return this.dataService.incomeTaxEntity.value?.aangifte?.box1?.winstUitOnderneming?.ondernemingen?.at(indexOnderneming)?.naam;
  }

  showButtonOpslaan(id: string): boolean {
    const toegestaneIds: string[] = [
      'Aangever',
      'Wijziging burgerlijke staat',
      'Partner',
      'Kinderen',
      'Ondernemingen',
      'Administratie inlezen',
      'Vragen vooraf',
      'Jaarstukken',
      'Resultatenrekening',
      'Balans activa',
      'Balans passiva',
      'Samenwerkingsverband',
      'Priveonttrekkingen en -stortingen',
      'Vermogensvergelijking',
      'Investeringen',
      'Winstcorrecties',
      'Ondernemersaftrek',
      'Overzicht winst',
      'Inkomsten uit loondienst',
      'Reiskosten openbaar vervoer',
      'Pensioen en andere uitkeringen',
      'Buitenlands loon',
      'Vrijgesteld loon',
      'Meer banen of uitkeringen tegelijk',
      'Resultaat uit overige werkzaamheden',
      'Terbeschikkingstellingsregeling',
      'Alimentatie',
      'Periodieke uitkeringen',
      'Woningen',
      'Eigenwoningschulden',
      'Financieringskosten',
      'Restschulden',
      'Huurinkomsten',
      'Overig eigen woning',
      'Premies lijfrente',
      'Jaar- en reserveringsruimte',
      'Overige premies inkomensvoorzieningen',
      'Teruggave premies inkomensvoorzieningen',
      'Aanmerkelijk belang (box 2)',
      'Werkelijk rendement',
      'Bankrekeningen',
      'Beleggingen',
      'Overige onroerende zaken',
      'Overige bezittingen',
      'Schulden',
      'Persoonsgebonden aftrek',
      'Specifieke zorgkosten',
      'Giften',
      'Scholingsuitgaven',
      'Onderhoudsverplichtingen',
      'Weekenduitgaven gehandicapte kinderen',
      'Restant persoonsgebonden aftrek voorgaande jaren',
      'Negatieve persoonsgebonden aftrek',
      'Voorlopige aanslagen',
      'Nederlandse dividendbelasting',
      'Buitenlandse bronbelasting',
      'Loon als onderdeel van winst',
      'Nog verrekenbaar',
      'Verdeling',
      'Premieplicht',
      'Wereldinkomen'
    ];

    return toegestaneIds.includes(id);
  }

  isOndernemingSpec(id: string): boolean {
    const ondernemingTabs: string[] = [
      'Administratie inlezen',
      'Vragen vooraf',
      'Resultatenrekening',
      'Balans activa',
      'Balans passiva',
      'Samenwerkingsverband',
      'Priveonttrekkingen en -stortingen',
      'Vermogensvergelijking',
      'Investeringen',
      'Winstcorrecties',
      'Jaarstukken'
    ];
    return ondernemingTabs.includes(id);
  }

  // public readonly config = ButtonConfiguration.create({
  //   onClick: () =>
  //     new Observable<void>((subscription) => {
  //       setTimeout(() => {
  //         this.saveAangifte();
  //
  //         subscription.next();
  //         subscription.complete(); // spinner stops here
  //       }, 200);
  //     }),
  // });

  public readonly config = ButtonConfiguration.create({
    onClick: () => {
      const incomeTaxEntity = this.dataService.incomeTaxEntity.value;

      return this.bokkzClient
        .postIncomeTax(
          incomeTaxEntity.sstRelationId!,
          false,
          false,
          false,
          false,
          incomeTaxEntity,
        )
        .pipe(
          take(1),
          map(() => void 0),
        );
    },

    onComplete: () => {
      console.log('aangifte opgeslagen');
    },

    onError: (err) => {
      console.log(err);

      this.toastService.showErrorMessage(
        'De gegevens zijn niet opgeslagen. De pagina wordt automatisch vernieuwd en probeer het daarna opnieuw.',
      );

      setTimeout(() => window.location.reload(), 3000);
    },

    onIsLoading: (isLoading) => {
      this.cdr.markForCheck();

      if (!isLoading) {
        setTimeout(() => this.cdr.detectChanges());
      }
    },
  });

  public isIdExcluded(id: string): boolean {
    return this.excludedIds.includes(id);
  }

  private excludedIds: string[] = [
    'Aangever',
    'Wijziging burgerlijke staat',
    'Partner',
    'Kinderen',
    'VIA inlezen',
    'Woningen',
    'Eigenwoningschulden',
    'Financieringskosten',
    'Restschulden',
    'Huurinkomsten',
    'Overig eigen woning',
    'Samenvatting eigen woning',
    'Aanmerkelijk belang (box 2)',
    'Inkomen uit aanmerkelijk belang',
    'Samenvatting aanmerkelijk belang',
    'Werkelijk rendement',
    'Bankrekeningen',
    'Beleggingen',
    'Overige onroerende zaken',
    'Overige bezittingen',
    'Schulden',
    'Samenvatting box 3',
    'Specifieke zorgkosten',
    'Giften',
    'Scholingsuitgaven',
    'Onderhoudsverplichtingen',
    'Weekenduitgaven gehandicapte kinderen',
    'Restant persoonsgebonden aftrek voorgaande jaren',
    'Samenvatting persoonsgebonden aftrek',
    'Nederlandse dividendbelasting',
    'Buitenlandse bronbelasting',
    'Verdeling',
    'Overzicht persoonsgebonden aftrek'
  ];

  get belastingdienstFisinUrl(): string {
    return `https://www.belastingdienst.nl/bibliotheek/handboeken/html/boeken/FISIN${this.year}/index.html`;
  }
}
